@import "tailwindcss";
@plugin "daisyui";

/* Custom styles for AI Avatar App */
@layer base {
  html {
    @apply antialiased;
  }
  
  body {
    @apply bg-base-200 text-base-content min-h-screen;
  }
}

@layer components {
  .avatar-container {
    @apply relative rounded-2xl overflow-hidden shadow-xl bg-gradient-to-b from-base-200 to-base-300;
  }
  
  .chat-card {
    @apply bg-base-100 border border-base-300 rounded-xl shadow-lg;
  }
  
  .message-bubble-user {
    @apply bg-primary text-primary-content rounded-2xl rounded-tr-sm px-4 py-2 shadow-sm;
  }
  
  .message-bubble-avatar {
    @apply bg-secondary/20 text-base-content rounded-2xl rounded-tl-sm px-4 py-2 shadow-sm;
  }
  
  .status-indicator {
    @apply flex items-center gap-2 text-sm font-medium;
  }
  
  .voice-button {
    @apply relative flex items-center justify-center w-12 h-12 rounded-full transition-all duration-200;
  }
  
  .voice-button.listening {
    @apply bg-error text-error-content animate-pulse;
  }
  
  .voice-button:not(.listening) {
    @apply bg-base-200 hover:bg-base-300 text-base-content;
  }
}

@layer utilities {
  .scrollbar-thin {
    scrollbar-width: thin;
    scrollbar-color: var(--color-base-300) transparent;
  }
  
  .scrollbar-thin::-webkit-scrollbar {
    width: 6px;
  }
  
  .scrollbar-thin::-webkit-scrollbar-track {
    background: transparent;
  }
  
  .scrollbar-thin::-webkit-scrollbar-thumb {
    background-color: var(--color-base-300);
    border-radius: 3px;
  }
}